<template>
  <div
    v-if="formateRangeDatasStatus"
    class="range-list clearfix"
  >
    <!-- 范围： -->
    <span
      class="range-tit"
    >{{ $t('message["288"]') }}：</span>
    <template v-if="formateRangeDatasStatus">
      <template>
        <a-cascader
          v-show="!checked"
          :popup-style="{position: isFixed ? 'fixed' : 'absolute', top: topStyle, 'z-index': 1053}"
          class="cascader-width"
          :options="rangeOptions"
          :placeholder="changeSelectPlace"
          change-on-select
          :value="rangeValue"
          @change="onChange"
        />
        <div
          v-show="checked"
          class="role-team-info-box"
        >
          <template v-if="Object.keys(selectObj).length && selectObj.allgroup">
            <div
              v-if="len<22"
              class="role-team-info"
            >
              {{ selectObj.label }}
              <span>[{{ roleTeamData }}]</span>
            </div>
            <a-popover
              v-else
              placement="bottom"
            >
              <template slot="content">
                <div class="more-role-box">
                  <h4> {{ selectObj.label }}</h4>
                  <div class="role-team-data-list">
                    <p
                      v-for="(item, key) in selectObj.allgroup"
                      :key="key"
                    >
                      {{ item }};
                    </p>
                  </div>
                </div>
              </template>
              <div class="role-team-info">
                {{ selectObj.label }}
                <span>[{{ roleTeamData }}]</span>
              </div>
            </a-popover>
          </template>
        </div>
      </template>
      <template v-if="isShow">
        <a-checkbox
          style="margin: 0 0 0 8px;"
          @change="onChangeHandler"
        >
          {{ $t('message["429"]') }}
        </a-checkbox>
        <span class="range-s-tip">
          <template v-if="!checked">[{{ $t('message["336"]') }}]</template>
          <template v-else>[{{ $t('message["1461"]') }}]</template>
        </span>
      </template>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      rangeOptions: [],
      rangeValue: [],
      selectObj: {},
      isShow: false,
      checked: false,
      isFixed: false,
      topStyle: 0
    }
  },
  computed: {
    ...mapState('statistic', ['memberRangeDatas', 'memberRangeDefaultDatas', 'formateRangeDatasStatus']),
    roleTeamData () {
      const { allgroup } = this.selectObj
      return Object.values(allgroup).join(';')
    },
    len () {
      const { allgroup, label } = this.selectObj
      const len1 = Object.values(allgroup).join(';').length
      return len1 + label.length
    },
    changeSelectPlace () {
      return this.$t('message["860"]')
    },
    fixedTop () {
      return this.type !== 'rec' ? '52px' : '103px'
    }
  },
  watch: {
    memberRangeDatas (val) {
      this.formateOptionsData(val)
      this.rangeOptions = val
    },
    memberRangeDefaultDatas (val) {
      if (!val) return
      this.rangeValue = val
    },
    type: {
      handler (val) {
        if (val === 'dev') {
          this.fetchGetMemberRangeDatas()
        } else if (val === 'rec') {
          this.fetchGetMemberRecRangeDatas()
        } else if (val === 'follow') {
          this.fetchGetMemberFollowRangeDatas()
        }
      },
      immediate: true
    }
  },
  mounted () {
    if (this.memberRangeDatas.length > 0) {
      this.formateOptionsData(this.memberRangeDatas)
      this.rangeOptions = this.memberRangeDatas
    }
    this.setStyle()
    window.addEventListener('resize', this.setStyle)
    document.addEventListener('scroll', this.setStyle)
  },
  methods: {
    ...mapActions('statistic', ['fetchGetMemberRangeDatas', 'fetchGetMemberRecRangeDatas', 'fetchGetMemberFollowRangeDatas']),
    onChange (value, value2) {
      this.rangeValue = value
      this.isShow = false
      this.selectObj = {}
      for (let i = 0; i < value2.length; i++) {
        for (let j in value2[i]) {
          if (j === 'ismerge' && value2[i][j] === 1) {
            this.selectObj = value2[i]
            this.isShow = true
          }
        }
      }
      this.$emit('handleRange', value)
    },
    onChangeHandler (e) {
      const b = e.target.checked
      if (b) {
        this.checked = true
        this.$emit('handleRange', this.rangeValue, true)
      } else {
        this.checked = false
        this.$emit('handleRange', this.rangeValue)
      }
    },
    formateOptionsData (array) {
      // let tempValue = []
      if (Array.isArray(array)) {
        // array.map(value => {
        //   const json = {
        //     value: value.keyname + '-' + value.id,
        //     label: value.name,
        //     children: []
        //   }
        //   if (value.children) {
        //     value.children.map(values => {
        //       const jsons = {
        //         label: values.name,
        //         value: values.keyname + '-' + values.id,
        //         children: []
        //       }
        //       if (values.children) {
        //         values.children.map(vitem => {
        //           jsons.children.push({
        //             label: vitem.name,
        //             value: vitem.keyname + '-' + vitem.id
        //           })
        //         })
        //       }
        //       json.children.push(jsons)
        //     })
        //   }
        //   tempValue.push(json)
        // })
        this.loopData(array)
      }
    },
    loopData (array) {
      array.forEach(item => {
        item['value'] = item.keyname + '-' + item.id
        item['label'] = item.name
        if (item.children && item.children.length) {
          this.loopData(item.children)
        }
      })
    },
    showMore () {},
    setStyle () {
      this.$nextTick(() => {
        let $rangeDom = document.querySelector('.role-select .range-list')
        if (!$rangeDom) {
          return false
        }
        const top = this.type === 'rec' ? 200 : 55
        this.isFixed = $rangeDom.style.position === 'fixed'
        this.topStyle = $rangeDom.style.position === 'fixed' ? this.fixedTop : $rangeDom.parentNode.offsetTop + $rangeDom.offsetHeight + top + 'px'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.cascader-width {
  width: 300px;
}
.range-list::v-deep {
  .range-tit {
    line-height: 32px;
    display: inline-block;
    float: left;
  }
  .cascader-width{
    float: left;
  }
  .ant-checkbox-wrapper {
    float: left;
    line-height: 32px;
  }
.role-team-info-box {
  position: relative;
  display: inline-block;
  float: left;
  .role-team-info {
  display: inline-block;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  padding: 0 10px;
  line-height: 32px;
  height: 32px;
  width: 300px;
  background: #f5f5f5;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  span {
    color: #b3b3b3;
    // max-width: 232px;
    // display: inline-block;
    // vertical-align: top;
  }
  }
}
}
.range-s-tip {
  color: #b3b3b3;
  float: left;
  line-height: 32px;
}
.more-role-box {
    width: 270px;
    h4{
      font-weight: bold;
      line-height: 24px;
    }
    .role-team-data-list {
      border-radius: 4px;
      background: #f7f7f7;
      line-height: 24px;
      padding: 8px;
      margin-top: 4px;
    }
  }

</style>
